import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MenuChangeEvent } from './api/menuchangeevent';
import { findFirstMenuUrl, readAssignedMenus } from '../shared/common/menu.util';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    private menuSource = new Subject<MenuChangeEvent>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();

    onMenuStateChange(event: MenuChangeEvent) {
        this.menuSource.next(event);
    }

    reset() {
        this.resetSource.next(true);
    }

    get homeRoute() {
        // findFirstMenuUrl walks the tree depth-first. The previous implementation read
        // sortedMenus[0].subMenus[0].menuUrl directly, which throws whenever the first top-level
        // menu is a leaf rather than a group.
        return findFirstMenuUrl(readAssignedMenus()) ?? '/account-portal/empty-landing';
    }
}
